import Flickity from "flickity";

class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = self.elem.querySelector('[data-carousel]');
        self.prevNextButtons = self.elem.getAttribute('data-prev-next-buttons');
    }

    init() {
        let self = this;

        // Flickity options
        let flktyOptions = {
            contain: true,
            draggable: true,
            wrapAround: true,
            pageDots: true,
            prevNextButtons: self.prevNextButtons ?? false,
            autoPlay: 4000,
            cellAlign: 'center',
        };

        // Initialise Flickity
        new Flickity(self.carousel, flktyOptions);
    }
}

export default Carousel;